import { CodedProperty, fluentValidator, stringArraysEqual, ValidationResult } from "sprint-common-web";

import { SuggestContentListByTitleResponseMovieVersion } from "../../../../../common/api/catalogue-api/contents-api/SuggestContentListByTitleResponse";
import { isTrailerVersionType } from "../../../../../common/types/TrailerContentVersion";

export const createOrderMovieItemValidator = () => {
    const validateVersion = (
        versionToValidate: SuggestContentListByTitleResponseMovieVersion,
        allVersions: SuggestContentListByTitleResponseMovieVersion[]
    ): ValidationResult => {
        return fluentValidator<SuggestContentListByTitleResponseMovieVersion>()
            .when((movieVersion) => {
                return !!movieVersion.buzzVersion?.isArchived;
            })
            .addError("Version is archived")
            .when((movieVersion) => !!movieVersion.buzzVersion?.notes && (movieVersion.brandings ?? []).length < 1)
            .addWarning((movieVersion) => movieVersion.buzzVersion?.notes ?? "")
            .when(isMovieVersionOrphaned)
            .addWarning("Version is orphaned")
            .when((movieVersion) => isDuplicated(allVersions, movieVersion))
            .addWarning((movieVersion) => movieVersion.buzzVersion?.name ?? "Version is duplicated")
            .validate(versionToValidate);
    };

    return {
        validateVersion
    };
};

const isMovieVersionOrphaned = (movieVersion: SuggestContentListByTitleResponseMovieVersion) => {
    return !movieVersion.buzzVersion?.id && !movieVersion.shreqVersion?.id && !isTrailerVersionType(movieVersion.type);
};

const isDuplicated = (
    movieVersions: SuggestContentListByTitleResponseMovieVersion[],
    movieVersion: SuggestContentListByTitleResponseMovieVersion
) => {
    return (
        movieVersions.filter(
            (version) =>
                version.type.id === movieVersion.type.id &&
                version.distributor.id === movieVersion.distributor.id &&
                brandingsEqual(movieVersion.brandings, version.brandings)
        ).length > 1
    );
};

const brandingsEqual = (brandings1?: CodedProperty[], brandings2?: CodedProperty[]) => {
    const brandings1Ids = brandings1?.map((brand: CodedProperty) => brand.id) ?? [];
    const brandings2Ids = brandings2?.map((brand: CodedProperty) => brand.id) ?? [];

    return stringArraysEqual(brandings1Ids, brandings2Ids);
};
